module.exports = __webpack_public_path__ + "static/media/poupanca.35b25f6b.png";